import { Routes, Route, NavLink, useLocation } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Templates from './pages/Templates';
import Connectors from './pages/Connectors';
import ConnectorNew from './pages/ConnectorNew';
import TestGenerate from './pages/TestGenerate';
import Logs from './pages/Logs';
import Dashboard from './pages/Dashboard';

// Designer pulls in @pdfme/ui (~1MB+). Lazy load so the rest of the app
// doesn't pay the cost on initial page load.
const Designer = lazy(() => import('./pages/Designer'));

function DesignerFallback() {
  return (
    <div className="empty" style={{ padding: 80, textAlign: 'center' }}>
      <div style={{ fontSize: 14, marginBottom: 12 }}>Carregando designer…</div>
      <div className="muted" style={{ fontSize: 12 }}>O @pdfme/ui tem ~1MB; baixa só quando você abre um template.</div>
    </div>
  );
}

const NAV = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/templates', label: 'Templates' },
  { to: '/connectors', label: 'Connectors' },
  { to: '/test', label: 'Test Generate' },
  { to: '/logs', label: 'Logs' },
];

const TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/templates': 'Templates',
  '/connectors': 'Connectors',
  '/connectors/new': 'New connector',
  '/test': 'Test Generate',
  '/logs': 'Generation logs',
};

export default function App() {
  const loc = useLocation();
  const title = TITLES[loc.pathname] || (loc.pathname.startsWith('/templates/') ? 'Edit template' : 'PDF Service');

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="logo">
          <div className="mark">P</div>
          <span>PDFService</span>
        </div>
        <nav className="nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => (isActive ? 'active' : '')}>
              {n.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="main">
        <header className="topbar">
          <h1>{title}</h1>
          <div className="row gap-sm">
            <a className="ghost btn" href="https://github.com/pdfme/pdfme" target="_blank" rel="noreferrer">pdfme docs ↗</a>
          </div>
        </header>
        <div className="content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/templates" element={<Templates />} />
            <Route
              path="/templates/:id"
              element={
                <Suspense fallback={<DesignerFallback />}>
                  <Designer />
                </Suspense>
              }
            />
            <Route
              path="/templates/new"
              element={
                <Suspense fallback={<DesignerFallback />}>
                  <Designer />
                </Suspense>
              }
            />
            <Route path="/connectors" element={<Connectors />} />
            <Route path="/connectors/new" element={<ConnectorNew />} />
            <Route path="/test" element={<TestGenerate />} />
            <Route path="/logs" element={<Logs />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}
